import axios from 'axios'
import { CALL_API } from 'tr-components/redux/CallApiMiddlewareActionCreator'

const FETCH_POSITIONS = 'Positions_Module/positions/FETCH_POSITIONS'
const FETCH_POSITIONS_SUCCESS = 'Positions_Module/positions/FETCH_POSITIONS_SUCCESS'
const FETCH_POSITIONS_FAIL = 'Positions_Module/positions/FETCH_POSITIONS_FAIL'

const FETCH_SECTIONS = 'Positions_Module/sections/FETCH_SECTIONS'
const FETCH_SECTIONS_SUCCESS = 'Positions_Module/sections/FETCH_SECTIONS_SUCCESS'
const FETCH_SECTIONS_FAIL = 'Positions_Module/sections/FETCH_SECTIONS_FAIL'

const FETCH_AVAILABLE_WORKFLOWS = 'Positions_Module/positions/FETCH_AVAILABLE_WORKFLOWS'
const FETCH_AVAILABLE_WORKFLOWS_SUCCESS =
  'Positions_Module/positions/FETCH_AVAILABLE_WORKFLOWS_SUCCESS'
const FETCH_AVAILABLE_WORKFLOWS_FAIL = 'Positions_Module/positions/FETCH_AVAILABLE_WORKFLOWS_FAIL'

const FETCH_POSITION_WORKFLOW = 'Positions_Module/positions/FETCH_POSITION_WORKFLOW'
const FETCH_POSITION_WORKFLOW_SUCCESS = 'Positions_Module/positions/FETCH_POSITION_WORKFLOW_SUCCESS'
const FETCH_POSITION_WORKFLOW_FAIL = 'Positions_Module/positions/FETCH_POSITION_WORKFLOW_FAIL'

const FETCH_POSITION_WORKFLOWS = 'Positions_Module/positions/FETCH_POSITION_WORKFLOWS'
const FETCH_POSITION_WORKFLOWS_SUCCESS =
  'Positions_Module/positions/FETCH_POSITION_WORKFLOWS_SUCCESS'
const FETCH_POSITION_WORKFLOWS_FAIL = 'Positions_Module/positions/FETCH_POSITION_WORKFLOWS_FAIL'
const WORKFLOW_SORT = 'Positions_Module/positions/WORKFLOW_SORT'

const FETCH_POSITION = 'Positions_Module/positions/FETCH_POSITION'
const FETCH_POSITION_SUCCESS = 'Positions_Module/positions/FETCH_POSITION_SUCCESS'
const FETCH_POSITION_FAIL = 'Positions_Module/positions/FETCH_POSITION_FAIL'

const FETCH_ASSOCIATIONS = 'Positions_Module/positions/FETCH_ASSOCITAIONS'
const FETCH_ASSOCIATIONS_SUCCESS = 'Positions_Module/positions/FETCH_ASSOCITAIONS_SUCESS'
const FETCH_ASSOCIATIONS_FAIL = 'Positions_Module/positions/FETCH_ASSOCITAIONS_FAIL'

const UPDATE_ASSOCIATIONS_PAGINATION = 'Positions_Module/positions/UPDATE_ASSOCIATIONS_PAGINATION'
const UPDATE_SELECTED_POSITION = 'Positions_Module/positions/UPDATE_SELECTED_POSITION'

const PERSIST_POSITION = 'Positions_Module/positions/PERSIST_POSITION'
const PERSIST_POSITION_SUCCESS = 'Positions_Module/positions/PERSIST_POSITION_SUCCESS'
const PERSIST_POSITION_FAIL = 'Positions_Module/positions/PERSIST_POSITION_FAIL'

const PERSIST_POSITION_WORKFLOW = 'Positions_Module/positions/PERSIST_POSITION_WORKFLOW'
const PERSIST_POSITION_WORKFLOW_SUCCESS =
  'Positions_Module/positions/PERSIST_POSITION_WORKFLOW_SUCCESS'
const PERSIST_POSITION_WORKFLOW_FAIL = 'Positions_Module/positions/PERSIST_POSITION_WORKFLOW_FAIL'

const PERSIST_BULK_WORKFLOWS = 'Positions_Module/positions/PERSIST_BULK_WORKFLOWS'
const PERSIST_BULK_WORKFLOWS_SUCCESS = 'Positions_Module/positions/PERSIST_BULK_WORKFLOWS_SUCCESS'
const PERSIST_BULK_WORKFLOWS_FAIL = 'Positions_Module/positions/PERSIST_BULK_WORKFLOWS_FAIL'

const SET_SNACKBAR_MESSAGE = 'Positions_Module/positions/SET_SNACKBAR_MESSAGE'
const CLEAR_SNACKBAR_MESSAGE = 'Positions_Module/positions/CLEAR_SNACKBAR_MESSAGE'

export const actions = {
  FETCH_POSITIONS,
  FETCH_POSITIONS_SUCCESS,
  FETCH_POSITIONS_FAIL,
  FETCH_ASSOCIATIONS,
  FETCH_ASSOCIATIONS_SUCCESS,
  FETCH_ASSOCIATIONS_FAIL,
  UPDATE_ASSOCIATIONS_PAGINATION,
  UPDATE_SELECTED_POSITION,
  FETCH_POSITION,
  FETCH_POSITION_SUCCESS,
  FETCH_POSITION_FAIL,
  PERSIST_POSITION,
  PERSIST_POSITION_SUCCESS,
  PERSIST_POSITION_FAIL,
  PERSIST_POSITION_WORKFLOW,
  PERSIST_POSITION_WORKFLOW_SUCCESS,
  PERSIST_POSITION_WORKFLOW_FAIL,
  PERSIST_BULK_WORKFLOWS,
  PERSIST_BULK_WORKFLOWS_SUCCESS,
  PERSIST_BULK_WORKFLOWS_FAIL,
  SET_SNACKBAR_MESSAGE,
  CLEAR_SNACKBAR_MESSAGE,
  WORKFLOW_SORT
}

export const processList = (list) =>
  list.map((x) =>
    Object.keys(x).reduce((acc, key) => {
      const keyVal =
        key === 'active' ? { status: x[key] ? 'Active' : 'Inactive' } : { [key]: x[key] }
      return { ...acc, ...keyVal }
    }, {})
  )

const attachWorkflowsToPositions = (positions, positionWorkflows) => {
  return positions.map((position) => {
    const matchingWorkflow = positionWorkflows.find(
      (workflow) => workflow.positionId === position.id
    )
    const workflow = matchingWorkflow ? matchingWorkflow.workflow : { name: 'Fast', workflowId: 2 }
    return { ...position, workflow }
  })
}

const sortByWorkflow = (positionsWithWorkflows, sortWorkflowDesc) => {
  sortWorkflowDesc
    ? positionsWithWorkflows.sort((a, b) => (a.workflow.name > b.workflow.name ? 1 : -1))
    : positionsWithWorkflows.sort((a, b) => (a.workflow.name < b.workflow.name ? 1 : -1))
  return positionsWithWorkflows
}

export const initialState = {
  savingPosition: false,
  savePositionError: null,
  savingPositionWorkflow: false,
  savePositionWorkflowError: null,
  snackbarMessage: null,

  positionDetails: null,
  fetchingDetails: false,
  fetchingDetailsError: null,
  list: [],
  positionsWithWorkflows: [],
  sortWorkflowDesc: true,
  query: {
    search: '',
    active: undefined,
    type: undefined,
    orderBy: 'internalDescription',
    desc: false
  },
  availableWorkflows: [],

  positionDetailsAssociations: {
    total: 0,
    list: [],
    sortStatus: {
      ascending: true,
      key: 'name'
    },
    pagination: {
      pageNumber: 1,
      pageSize: 30
    },
    visiblePageButtonsCount: 5,
    rowsPerPageOptions: [10, 30, 50],
    fetchingAssociations: false,
    fetchingAssociationsError: null
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_ASSOCIATIONS_PAGINATION:
      return {
        ...state,
        positionDetailsAssociations: {
          ...state.positionDetailsAssociations,
          pagination: action.payload
        }
      }
    case UPDATE_SELECTED_POSITION:
      return {
        ...state,
        list: state.list.map((pos) =>
          pos.id === action.payload.id ? { ...pos, selected: action.payload.selected } : pos
        )
      }
    case FETCH_ASSOCIATIONS:
      return {
        ...state,
        positionDetailsAssociations: {
          ...state.positionDetailsAssociations,
          fetchingAssociations: true,
          fetchingAssociationsError: null
        }
      }
    case FETCH_ASSOCIATIONS_SUCCESS:
      return {
        ...state,
        positionDetailsAssociations: {
          ...state.positionDetailsAssociations,
          total: parseInt(action.headers['total-count'], 10),
          list: action.payload,
          fetchingAssociations: false
        }
      }
    case FETCH_ASSOCIATIONS_FAIL:
      return {
        ...state,
        positionDetailsAssociations: {
          ...state.positionDetailsAssociations,
          fetchingAssociations: false,
          fetchingAssociationsError: action.payload
        }
      }
    case FETCH_POSITION:
      return {
        ...state,
        fetchingDetails: true,
        fetchingDetailsError: null
      }
    case FETCH_POSITION_SUCCESS:
      return {
        ...state,
        fetchingDetails: false,
        positionDetails: action.payload
      }
    case FETCH_POSITION_FAIL:
      return {
        ...state,
        fetchingDetails: false,
        fetchingDetailsError: action.payload
      }
    case FETCH_POSITIONS:
      return {
        ...state,
        loading: true,
        fetchingDetails: false,
        positionDetails: null
      }
    case FETCH_POSITIONS_SUCCESS:
      return {
        ...state,
        list: processList(action.payload.positions),
        query: action.requestPayload
      }
    case FETCH_POSITIONS_FAIL:
      return {
        ...state,
        loading: false
      }
    case FETCH_AVAILABLE_WORKFLOWS:
      return {
        ...state,
        loading: true
      }
    case FETCH_AVAILABLE_WORKFLOWS_SUCCESS:
      return {
        ...state,
        loading: false,
        availableWorkflows: action.payload
      }
    case FETCH_AVAILABLE_WORKFLOWS_FAIL:
      return {
        ...state,
        loading: false
      }
    case FETCH_SECTIONS:
      return {
        ...state,
        loading: true
      }
    case FETCH_SECTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        sections: action.payload
      }
    case FETCH_SECTIONS_FAIL:
      return {
        ...state,
        loading: false
      }
    case FETCH_POSITION_WORKFLOW:
      return {
        ...state,
        loading: true
      }
    case FETCH_POSITION_WORKFLOW_SUCCESS:
      return {
        ...state,
        positionWorkflow: { ...action.payload, workflowId: `${action.payload.workflowId}` },
        loading: false
      }
    case FETCH_POSITION_WORKFLOW_FAIL:
      return {
        ...state,
        loading: false
      }
    case FETCH_POSITION_WORKFLOWS:
      return {
        ...state,
        loading: true
      }
    case FETCH_POSITION_WORKFLOWS_SUCCESS:
      return {
        ...state,
        positionsWithWorkflows: attachWorkflowsToPositions(state.list, action.payload),
        loading: false
      }
    case FETCH_POSITION_WORKFLOWS_FAIL:
      return {
        ...state,
        loading: false
      }
    case PERSIST_POSITION:
      return {
        ...state,
        savingPosition: true,
        savePositionError: null
      }
    case PERSIST_POSITION_SUCCESS:
      return {
        ...state,
        savingPosition: false
      }
    case PERSIST_POSITION_FAIL:
      return {
        ...state,
        savingPosition: false,
        savePositionError: action.payload
      }
    case PERSIST_POSITION_WORKFLOW:
      return {
        ...state,
        savingPositionWorkflow: true,
        savePositionWorkflowError: null
      }
    case PERSIST_POSITION_WORKFLOW_SUCCESS:
      return {
        ...state,
        savingPositionWorkflow: false
      }
    case PERSIST_POSITION_WORKFLOW_FAIL:
      return {
        ...state,
        savingPositionWorkflow: false,
        savePositionWorkflowError: action.payload
      }
    case SET_SNACKBAR_MESSAGE:
      return {
        ...state,
        snackbarMessage: action.payload
      }
    case CLEAR_SNACKBAR_MESSAGE:
      return {
        ...state,
        snackbarMessage: null
      }

    case WORKFLOW_SORT:
      return {
        ...state,
        positionsWithWorkflows: sortByWorkflow(
          state.positionsWithWorkflows,
          state.sortWorkflowDesc
        ),
        list: processList(state.list),
        sortWorkflowDesc: !state.sortWorkflowDesc
      }
    default:
      return state
  }
}

export default reducer

export const setSnackBarMessage = (message) => ({
  type: SET_SNACKBAR_MESSAGE,
  payload: message
})

export const clearSnackbarMessage = () => ({
  type: CLEAR_SNACKBAR_MESSAGE
})

export const updatePagination = (pid, pagination) => (dispatch) => {
  dispatch({
    type: UPDATE_ASSOCIATIONS_PAGINATION,
    payload: pagination
  })
  dispatch(fetchAssociations(pid))
}

export const updateSelectedPosition = (id, selected) => ({
  type: UPDATE_SELECTED_POSITION,
  payload: { id, selected }
})

const fetchAssociations = (pid) => (dispatch, getState) => {
  dispatch({
    type: CALL_API,
    types: [FETCH_ASSOCIATIONS, FETCH_ASSOCIATIONS_SUCCESS, FETCH_ASSOCIATIONS_FAIL],
    callAPI: () =>
      axios.get(`/positions/${pid}/associations`, {
        headers: { 'x-api': 'positions_v2' },
        params: {
          ...getState().Positions.positions.positionDetailsAssociations.pagination
        }
      }),
    payload: pid
  })
}

export const fetchPosition = (id) => ({
  type: CALL_API,
  types: [FETCH_POSITION, FETCH_POSITION_SUCCESS, FETCH_POSITION_FAIL],
  callAPI: () => axios.get(`/positions/${id}`, { headers: { 'x-api': 'positions_v3' } }),
  payload: id
})

export const saveOrUpdate = (position) => ({
  type: CALL_API,
  types: [PERSIST_POSITION, PERSIST_POSITION_SUCCESS, PERSIST_POSITION_FAIL],
  callAPI: () =>
    axios.patch(`/positions/${position.id}`, position, { headers: { 'x-api': 'positions_v3' } })
})

export const updateWorkflow = (positionId, workflow) => ({
  type: CALL_API,
  types: [
    PERSIST_POSITION_WORKFLOW,
    PERSIST_POSITION_WORKFLOW_SUCCESS,
    PERSIST_POSITION_WORKFLOW_FAIL
  ],
  callAPI: () =>
    axios.put(`/positions/${positionId}/workflows`, workflow, {
      headers: {
        'x-api': 'APPLICATION_WORKFLOW_V1'
      }
    })
})

export const fetchPositions = (query) => {
  return {
    type: CALL_API,
    types: [FETCH_POSITIONS, FETCH_POSITIONS_SUCCESS, FETCH_POSITIONS_FAIL],
    callAPI: () =>
      axios.get('/positions', {
        headers: { 'x-api': 'positions_v2' },
        params: {
          ...query,
          orderBy: query.orderBy === 'status' ? 'active' : query.orderBy
        }
      }),
    payload: query
  }
}

export const fetchWorkflows = () => {
  return {
    type: CALL_API,
    types: [
      FETCH_POSITION_WORKFLOWS,
      FETCH_POSITION_WORKFLOWS_SUCCESS,
      FETCH_POSITION_WORKFLOWS_FAIL
    ],
    callAPI: () =>
      axios.get('/positions', {
        headers: { 'x-api': 'APPLICATION_WORKFLOW_V1' }
      })
  }
}

export const fetchPositionsAndWorkflows = (query) => async (dispatch) => {
  await dispatch(fetchPositions(query))
  return await dispatch(fetchWorkflows())
}

export const workflowSort = () => {
  return {
    type: WORKFLOW_SORT
  }
}

export const fetchAvailableWorkflows = () => {
  return {
    type: CALL_API,
    types: [
      FETCH_AVAILABLE_WORKFLOWS,
      FETCH_AVAILABLE_WORKFLOWS_SUCCESS,
      FETCH_AVAILABLE_WORKFLOWS_FAIL
    ],
    callAPI: () => axios.get('/workflows', { headers: { 'x-api': 'APPLICATION_WORKFLOW_V1' } })
  }
}

export const fetchWorkflow = (positionId) => {
  return {
    type: CALL_API,
    types: [FETCH_POSITION_WORKFLOW, FETCH_POSITION_WORKFLOW_SUCCESS, FETCH_POSITION_WORKFLOW_FAIL],
    callAPI: () =>
      axios.get(`/positions/${positionId}/workflows`, {
        headers: { 'x-api': 'APPLICATION_WORKFLOW_V1' }
      })
  }
}

export const fetchPositionAndWorkflow = (id) => (dispatch) => {
  return dispatch(fetchPosition(id)).then(() => {
    return dispatch(fetchWorkflow(id))
  })
}
export const updateBulkWorkflows = (positions) => {
  return {
    type: CALL_API,
    types: [PERSIST_BULK_WORKFLOWS, PERSIST_BULK_WORKFLOWS_SUCCESS, PERSIST_BULK_WORKFLOWS_FAIL],
    callAPI: () =>
      axios.patch('/positions', positions, { headers: { 'x-api': 'APPLICATION_WORKFLOW_V1' } })
  }
}

export const fetchSections = () => {
  return {
    type: CALL_API,
    types: [FETCH_SECTIONS, FETCH_SECTIONS_SUCCESS, FETCH_SECTIONS_FAIL],
    callAPI: () => axios.get('/sections', { headers: { 'x-api': 'APPLICATION_WORKFLOW_V1' } })
  }
}



// WEBPACK FOOTER //
// ./src/modules/Positions/reducers/positions.js